import React from 'react';
import './EventCard.scss';

export default function EventCardSkeleton() {
  return (
    <div className="EventCard" data-testid="event-card-skeleton" style={{ minWidth: '200px' }}>
      <div className="image skeleton" data-testid="event-card-image-skeleton" style={{ height: '100px' }} />
      <div className="info">
        <div className="venue-name skeleton" data-testid="event-card-venue-name-skeleton" style={{ height: '25px', width: '100%', marginBottom: '2px' }} />
        <div className="event-name skeleton" data-testid="event-card-event-name-skeleton" style={{ height: '25px', width: '50%', marginBottom: '2px' }} />
        <div className="date skeleton" style={{ height: '25px', width: '70%', marginBottom: '2px' }} />
        <div className="neighborhood skeleton" style={{ height: '25px', width: '90%', marginBottom: '2px' }} />
      </div>
    </div>
  );
}

EventCardSkeleton.displayName = 'EventCardSkeleton';
